import { CheckinInsertPayload, CheckinUpdatePayload, CheckoutInsertPayload, Kit } from "../types/checkInOut.types";
import { baseHttp } from "./baseHttp";


const getKits = async (surgeryUUID: string, articleTypeCode: string = "06"): Promise<Kit[]> => {
    const payload = [
        {
            field: "t.surgery_baselist_uuid",
            operator: "equal",
            value: surgeryUUID
        },
        {
            field: "articletype.code",
            operator: "equal",
            value: articleTypeCode
        }
    ];
    return baseHttp.post(`/api/n/surgery-baselist-articles/filter?q=1&page=1&take=10000`, payload).then((response: any) => {
        return (response.data?.list || []).map((el: Kit) => {
            return {
                uuid: el.uuid, // uuid della tabella surgery_baselist_articles
                surgery_baselist_uuid: el.surgery_baselist_uuid, // uuid della tabella surgery_baselist
                quantity: el.quantity, // quantità dichiarata
                order_index: el.order_index, // ordine di inserimento
                article: { // info articolo che in questo caso rappresenta il kit
                    uuid: el.article.uuid,
                    code: el.article.code,
                    description: el.article.description,
                    notes: el.article.notes,
                    barcode: el.article.barcode
                }
            }
        });
    }).catch((error: any) => {
        console.error(error);
        return [];
    });
}


const getKitComponents = async (payload: {barcode: string, code: string}) => {
    return baseHttp.post(`/sixster-integrations/q/serial-kit/rows/_list`, payload)
        .then((response: any) => response.data)
        .catch((error: any) => {
            console.error(error);
            return [];
        });
}


const getKitCheckedIn = async (surgeryManagementUUID: string) => {
    return baseHttp.get(`/api/n/sixter-kits-check-in/surgery-management/${surgeryManagementUUID}`).then((response: any) => {
        return response.data;
    }).catch((error: any) => {
        console.error(error);
        return [];
    });
}

const getKitCheckedOut = async (surgeryManagementUUID: string) => {
    return baseHttp.get(`/api/n/sixter-kits-check-out/surgery-management/${surgeryManagementUUID}`)
        .then((response: any) => {
            return response.data;
        }).catch((error: any) => {
            console.error(error);
            return [];
        });
}

const save = async (type: string, payload: CheckinInsertPayload | CheckoutInsertPayload) => {
    return baseHttp.post(`api/n/sixter-kits-${type}`, payload).then((response: any) => {
        return response.data;
    }).catch((error: any) => {
        console.error(error);
        return [];
    });
};


const cancel = async (type: string, checkinUUID: string) => {
    return baseHttp.delete(`api/n/sixter-kits-${type}/${checkinUUID}`)
    .then((response: any) => {
        return response.data;
    }).catch((error: any) => {
        console.error(error);
        return [];
    });
}



const update = async (type: string, checkinUUID: string, payload: CheckinUpdatePayload) => {
    return baseHttp.patch(`api/n/sixter-kits-${type}/${checkinUUID}`, payload).then((response: any) => {
        return response.data;
    }).catch((error: any) => {
        console.error(error);
        return [];
    });
}


const CheckinService = {
    getKits,
    getKitComponents,
    update,
    getKitCheckedIn,
    getKitCheckedOut,
    save,
    cancel
}

export default CheckinService;